import {Outlet} from "react-router-dom";

const Examination = () => {
  return <Outlet/>
}

export default Examination;